import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav-bar-cerrado',
  templateUrl: './nav-bar-cerrado.component.html',
  styleUrls: ['./nav-bar-cerrado.component.scss']
})
export class NavBarCerradoComponent implements OnInit {
  status: boolean = false;
  nro_Jurisdiccion = environment.codigoJur;
  cidi;
  constructor(private readonly route: ActivatedRoute) { }

  ngOnInit() {

    this.route.queryParams
    .filter((params) => params.cidi)
    .subscribe((params) => {
      this.cidi = params.cidi;
      const cidi = params.cidi;
      sessionStorage.setItem("cidi", cidi);
     
    });
 
  }
  //toglle bar
  clickEvent() {
    this.status = !this.status;       
  }

}
